import { Routes, Route } from 'react-router-dom'
import Users from './index/Users'
import UserForm from './form/UserForm'
import { useStateContext } from 'context/ContextProvider'
import { Role } from 'types'
import Page404 from 'views/errors/Page404'

const ClientsRoutes = () => {
  const { user } = useStateContext()

  if( !user?.roles.includes(Role.Admin)){
    return <Page404 />
  }

  return (
    <Routes>
      <Route path="/">
        <Route
          index
          element={<Users />}
        />
        <Route
          path="new"
          element={<UserForm key="accountCreate" />}
        />
        <Route
          path=":id"
          element={<UserForm key="accountUpdate" />}
        />
      </Route>
    </Routes>
  )
}

export default ClientsRoutes
